var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.229 18.915l-9.15-7.785a.546.546 0 00-.707 0l-9.18 7.819a.545.545 0 00.706.83l.072-.062v9.766c0 .3.244.545.545.545H28.87a.545.545 0 00.545-.545v-9.828l.107.09a.545.545 0 10.706-.83zm-7.355 9.989h-4.361v-6.36h4.36v6.36zm5.452.034h-4.361v-6.94a.545.545 0 00-.545-.544h-5.452a.545.545 0 00-.545.545v6.939h-4.361v-10.15l7.664-6.527 7.6 6.466v10.21z"
  })));
}

export default SvgHomeIcon;